var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 31,
    viewBox: "0 0 23 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.60891 9.32648L10.2828 1.65261C10.9193 1.01604 11.9514 1.01604 12.588 1.65261L20.2619 9.32648C20.8984 9.96304 20.8984 10.9951 20.2619 11.6317L12.588 19.3056C11.9514 19.9421 10.9193 19.9421 10.2828 19.3056L2.60891 11.6317C1.97234 10.9951 1.97234 9.96304 2.60891 9.32648Z",
    fill: "#FEDD58"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5351 13.9853C20.9113 13.6091 21.5422 13.6887 21.7705 14.1693C22.4753 15.6532 22.8711 17.3124 22.8711 19.0644C22.8708 25.3799 17.751 30.4999 11.4355 30.4999C5.12012 30.4999 0.000247639 25.3799 0 19.0644C0 17.3126 0.39523 15.6532 1.09973 14.1693C1.32791 13.6887 1.95881 13.6091 2.33504 13.9853L10.8592 22.5087C11.1775 22.8269 11.6935 22.8269 12.0118 22.5086L20.5351 13.9853Z",
    fill: "#FEDD58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedaIcon);
export default __webpack_public_path__ + "static/media/feeda-icon.930b1c321a28356a2b3791c95a25121a.svg";
export { ForwardRef as ReactComponent };